module.exports = __webpack_public_path__ + "static/media/bh.392927ca.svg";